<script>
    import { mapActions } from 'vuex';

    export default {
        props: {},

        methods: {
            ...mapActions('breadcrumbs', ['setFacet']),
        },

        mounted() {
            this.setFacet({ facet: 'dark-background' });
        },

        render() {
            return null;
        },
    };
</script>
